/** Parse common GitHub repo URL / shorthand into API { owner, repo }. */

export function parseGithubRepoUrl(raw: string): { owner: string; repo: string } | null {
  const s = raw.trim();
  if (!s) return null;

  const ssh = /^git@github\.com:([^/]+)\/([^/]+?)(\.git)?$/i.exec(s);
  if (ssh) {
    const owner = ssh[1]!.trim();
    const repo = ssh[2]!.replace(/\.git$/i, '').trim();
    if (owner && repo && !owner.includes('/') && !repo.includes('/')) return { owner, repo };
    return null;
  }

  try {
    const withProtocol = /^https?:\/\//i.test(s) ? s : `https://${s}`;
    const u = new URL(withProtocol);
    const host = u.hostname.replace(/^www\./i, '').toLowerCase();
    if (host === 'github.com') {
      const parts = u.pathname.split('/').filter(Boolean);
      if (parts.length < 2) return null;
      const owner = parts[0]!;
      let repo = parts[1]!.replace(/\.git$/i, '');
      if (!owner || !repo || owner.includes('/') || repo.includes('/')) return null;
      return { owner, repo };
    }
  } catch {
    /* fall through */
  }

  const shorthand = /^([a-zA-Z0-9_.-]+)\/([a-zA-Z0-9_.-]+)$/.exec(s);
  if (shorthand) {
    const owner = shorthand[1]!.trim();
    let repo = shorthand[2]!.trim().replace(/\.git$/i, '');
    if (owner.toLowerCase() === 'github.com') return null;
    if (owner && repo && !owner.includes('/') && !repo.includes('/')) return { owner, repo };
  }

  return null;
}
